/**
 * Normalizes Firestore Timestamp date fields to yyyy-MM-dd strings.
 * @param {import('@/types').Task} taskData
 */
export function normalizeTaskDateField(taskData) {
  if (taskData.date && typeof taskData.date.toDate === 'function') {
    const jsDate = taskData.date.toDate();
    const year = jsDate.getFullYear();
    const month = String(jsDate.getMonth() + 1).padStart(2, '0');
    const day = String(jsDate.getDate()).padStart(2, '0');
    taskData.date = `${year}-${month}-${day}`;
  }
  return taskData;
}

/**
 * @param {object} params
 * @param {import('@/types').Task | null} params.initialTask
 * @param {string | null} params.taskId
 * @param {string} params.title
 * @param {import('@/types').Task[]} params.allTasks
 * @param {(task: import('@/types').UpdateTask) => Promise<string | void>} params.addTask
 * @param {(id: string, data: import('@/types').UpdateTask, uid: string) => Promise<void>} params.updateTaskDetails
 * @param {(data: import('@/types').UpdateTask, id: string | null, initial: import('@/types').Task | null, tasks: import('@/types').Task[]) => import('@/types').UpdateTask} params.prepareTaskData
 */
export async function submitTaskModalForm({
  taskDataFromForm,
  taskId,
  title,
  initialTask,
  allTasks,
  addTask,
  updateTaskDetails,
  prepareTaskData,
  userUid,
}) {
  const pendingSubtasks = taskDataFromForm?.pendingSubtasks ?? [];
  const { pendingSubtasks: _ignored, ...mainTaskDataFromForm } =
    taskDataFromForm ?? {};
  const withTitle = {
    ...mainTaskDataFromForm,
    title: title || mainTaskDataFromForm.title,
  };

  const taskDataForFirestore = prepareTaskData(
    withTitle,
    taskId,
    initialTask,
    allTasks,
  );

  if (taskId) {
    await updateTaskDetails(taskId, taskDataForFirestore, userUid);
    return true;
  }

  const newParentId = await addTask(taskDataForFirestore);

  if (
    Array.isArray(pendingSubtasks) &&
    pendingSubtasks.length > 0 &&
    newParentId
  ) {
    for (const st of pendingSubtasks) {
      if (!st?.title) continue;
      const { localId, ...subtaskFields } = st;
      await addTask({
        ...subtaskFields,
        parentId: newParentId,
        time: subtaskFields.time ?? null,
      });
    }
  }

  return true;
}
